import ServiceLedger from "../components/ServiceLedger";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function Services() {
  return (
    <div data-testid="services-page" style={{ background: "var(--ivory)" }}>
      <section className="pt-16 pb-8">
        <div className="max-w-[1500px] mx-auto px-5 sm:px-8 lg:px-12">
          <div className="font-mono text-[10px] uppercase tracking-[0.28em]" style={{ color: "var(--muted)" }}>Chapter Two · The Catalogue</div>
          <h1 className="font-display mt-6" style={{ fontSize: "clamp(3rem, 8vw, 7rem)", lineHeight: 0.9, letterSpacing: "-0.04em" }}>
            Every <span className="font-display-italic" style={{ color: "var(--brass)" }}>service</span>,
            <br />filed and <span className="font-display-italic" style={{ color: "var(--terracotta)" }}>accountable.</span>
          </h1>
          <p className="mt-8 font-body text-xl max-w-2xl" style={{ color: "var(--navy-soft)", lineHeight: 1.5 }}>
            Every discipline in the Bespoke ledger is scoped to your property, cadenced to your operation, and executed by a fully vetted crew.
          </p>
        </div>
      </section>

      <ServiceLedger />

      <section className="py-20" style={{ background: "var(--navy)", color: "var(--ivory)" }}>
        <div className="max-w-[1500px] mx-auto px-5 sm:px-8 lg:px-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.28em]" style={{ color: "var(--brass-soft)" }}>Next</div>
            <div className="font-display text-4xl md:text-5xl mt-2" style={{ letterSpacing: "-0.03em" }}>
              Submit the <span className="font-display-italic" style={{ color: "var(--brass-soft)" }}>brief.</span>
            </div>
          </div>
          <Link to="/quote" className="btn-primary" style={{ background: "var(--brass)", borderColor: "var(--brass)", color: "var(--text)" }}>Request Assessment <ArrowUpRight size={14} className="arrow" /></Link>
        </div>
      </section>
    </div>
  );
}
